import { AlignType, HeaderType } from 'src/components/UI/CustomUI/organisms/Table/types'

import { Typography } from '@mui/material'
import moment from 'moment'
import { Button } from 'src/components/UI'


const headers: HeaderType[] = [
    {
        id: 'invoiceNum',
        label: 'Invoice Number',
    },
    {
        id: 'amount',
        label: 'Amount',
        custom: true,
        Element: (row: any): JSX.Element => {
            return (
                <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                    {row?.amount > 0 ? `$${row?.amount}` : `-$${row?.amount * -1}`}
                </Typography>
            )
        },

    },
    {
        id: 'orderName',
        label: 'Work Order',
        maxWidth: 200,
    },
    {
        id: 'insertedOn',
        label: 'Added',
        maxWidth: 200,
        custom: true,
        align: 'center' as AlignType,
        Element: (row: any): JSX.Element => {
            return (
                <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                    {moment.unix(row?.insertedOn).format('MM/DD/YYYY')}
                </Typography>
            )
        },
    },
    {
        id: 'view',
        label: 'View',
        maxWidth: 200,
        custom: true,
        align: 'center' as AlignType,
        Element: (row: any): JSX.Element => {
            return (
                <Button
                    variant='contained'
                    color='primary'
                    sx={{ width: '75px', height: '26px' }}
                    href={row.fileUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    View
                </Button>
            )
        },
    },
]
export default headers
